const HeroBanner = () => {
  return (
    <div className="wp-hero">
      <div className="wp-hero__inner">
        <div>
          <span className="wp-hero__badge">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
            Trusted by 4,00,000+ households
          </span>
          <h1>Register your appliance warranty in minutes</h1>
          <p>
            Protect your purchase with effortless claim processing and priority
            service — backed by a formal, verifiable warranty record.
          </p>
        </div>
        <img
          src="/imgg.png"
          alt="Appliance protection illustration"
          className="wp-hero__image"
        />
      </div>
    </div>
  );
};

export default HeroBanner;
